import { useTranslation } from "react-i18next";
import { useState } from "react";
import { buildRiskObject, isOnlyNumber } from "../../pages/utils";
import { Consts } from "../../pages/consts";
import GenoAndPhenoSelection from "./GenoAndPhenoSelection";

const PhenoGenotype = ({ gene, allGenes, onSetGene }) => {
  const { t: t } = useTranslation();
  const [phenotype, setPhenotype] = useState("");
  const [allele1, setAllele1] = useState(t(Consts.NOT_SPECIFIED));
  const [allele2, setAllele2] = useState(t(Consts.NOT_SPECIFIED));

  const handleSetGeneDetails = () => {
    const filteredGenes = allGenes?.filter((g) => g.geneName === gene?.geneName);

    let genotype = [
      (allele1 && (isOnlyNumber(allele1) || allele1 === "4A/B" || allele1 === "1173C>T" || allele1 === "XN")
          ? "*"
          : ""
      ) + (allele1 || t(Consts.NOT_SPECIFIED)),
      (allele2 && (isOnlyNumber(allele2) || allele2 === "4A/B" || allele1 === "1173C>T" || allele1 === "XN")
        ? "*"
        : ""
      ) + (allele2 || t(Consts.NOT_SPECIFIED)),
    ]?.join("/");

    genotype = formatGenotype(genotype);

    if (filteredGenes?.length > 0) {
      const riskObj = buildRiskObject(phenotype, genotype, filteredGenes[0]);

      onSetGene({
        ...gene,
        phenotype,
        genotype,
        risks: riskObj.risks,
        genoRisks: riskObj.genoRisks,
        phenoRisks: riskObj.phenoRisks,
      });
    }
  };

  const formatGenotype = (genotype) => {
    genotype = genotype?.toLowerCase();
    const isNotSpecified = genotype === `${t(Consts.NOT_SPECIFIED)?.toLowerCase()}
    /${t(Consts.NOT_SPECIFIED)?.toLowerCase()}`;

    return isNotSpecified
      ? t(Consts.NOT_SPECIFIED)?.toLowerCase()
      : genotype?.replaceAll('4a/b', '4A/B')?.replaceAll('c>t', 'C>T')?.replaceAll('xn', 'XN');
  };

  return (
    <div className="w3-modal" style={{ display: Consts.BLOCK }}>
      <div className="w3-modal-content w3-card-4 w3-animate-zoom form-panel dialog-narrow">
        <header className="w3-container w3-padding-small w3-center">
          <p>
            {t("gene")} {gene?.geneName}: {t("select_pheno_geno")}
          </p>
        </header>
        <div className="w3-container w3-padding-small w3-margin-left">
          <GenoAndPhenoSelection
            setPhenotype={(value) => setPhenotype(value)}
            setAllele1={setAllele1}
            setAllele2={setAllele2}
          />
        </div>
        <footer className="w3-container w3-padding-small">
          <p className="w3-right">
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5"
              onClick={handleSetGeneDetails}
            >
              {t("submit")}
            </button>
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={() => onSetGene(null)}
            >
              {t("cancel")}
            </button>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PhenoGenotype;
